import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState, useContext } from "react";
import { Fragment } from "react";
import {
  Button,
  Alert,
  Card,
  CardBody,
  CardFooter,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  Table,
  Badge,
  Spinner,
} from "reactstrap";
import { findMyServicesAsManager } from "../../helpers/api/finance";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import FalconCardHeader from "../common/FalconCardHeader";
import PageHeader from "../common/PageHeader";
import { Link, useParams } from "react-router-dom";
import NumberFormat from "react-number-format";
import FullPagination from "../common/pagination/FullPagination";
import Filter from "../common/Filter";
import { Message, Or, PreloadState } from "../UI/preloading/PreloadState";
import { isIterableArray } from "../../helpers/utils";
import {
  faCheck,
  faInfoCircle,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import classNames from "classnames";
import Flex from "../common/Flex";
import SupportLink from "../root/support/components/SupportLink";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import {
  fetchCondominiums,
  findAllProperties,
} from "../../helpers/api/condominium";
import moment from "moment";
import { useSelector } from "react-redux";
import { getConfigAsRoot } from "../../helpers/api/root";
import { Toast } from "../UI/toast/Toast";
import { CurrencyContext } from "../../context/Context";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const MyService = () => {
  const moduleBase = useModuleBase();

  const history = useHistory();
  const { condominiumId } = useParams();
  const { token } = useSelector((state) => state.auth.user);
  const { baseCurrency } = useContext(CurrencyContext);
  const [params, setParams] = useState({ condominiumId: condominiumId });
  const [properties, setProperties] = useState(null);
  const [loading, setLoading] = useState(false);
  const [prices, setPrices] = useState(null);

  const filter_options = [
    { value: 0, displayName: "Todos", disabled: false },
    { value: "active", displayName: "Activos", disabled: false },
    { value: "inactive", displayName: "Inactivos", disabled: false },
  ];

  const {
    data,
    error,
    isLoading,
    /*   mutate, */
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(findMyServicesAsManager, params);

  const [param, setParam] = useState({
    search: null,
    token: token,
  });

  console.log(data);

  const {
    data: dataC,
    error: errorC,
    isLoading: isLoadingC,
    mutate,
    meta: metaC,
    handler: {
      nextPage: nextPageC,
      previousPage: previousPageC,
      perPage: perPageC,
      goToPage: goToPageC,
    },
  } = useSWRFetchPagination(fetchCondominiums, param);

  const condominioS = dataC.find(
    (dat) => dat?.condominium_id === Number(condominiumId)
  );

  console.log(condominioS);

  /*   useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        getConfigAsRoot()
          .then(({ data }) => {
            isMounted && setPrices(data);
          })
          .catch(() => {
            Toast.fire({
              type: "error",
              title: "Ha ocurrido un error al calcular el monto.",
            });
          });
        const {
          meta: { total },
        } = await findAllProperties(condominiumId);
        isMounted && setProperties(total);
      } catch (error) {
        handleErrorMessage(error);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [condominiumId]); */

  const condominio = data.filter(
    (dat) => dat?.condominium?.condominium_id === Number(condominiumId)
  );

  const status = data.filter(
    (dat) =>
      dat?.condominium?.condominium_id === Number(condominiumId) &&
      dat?.charge?.paid === 0
  );

  console.log(status);
  const {
    data: datab,
    /*         mutate, */
    meta: metab,
    handler: {
      nextPage: next,
      previousPage: prev,
      perPage: per,
      goToPage: goTo,
    },
  } = useSWRFetchPagination(condominio);

  console.log(datab);

  useEffect(() => {
    if (condominiumId) {
      setLoading(true);
      findAllProperties(condominiumId)
        .then(({ meta: { total } }) => setProperties(total))
        .catch((err) => handleErrorMessage(err))
        .finally(() => setLoading(false));
    }
  }, [condominiumId]);
  console.log(condominioS);

  useEffect(() => {
    if (error) handleErrorMessage(error);
  }, [error]);

  return (
    <Fragment>
      <PageHeader
        title="Estado de mi servicio"
        titleTag="h2"
        description={"Visualiza el estado del servico del sistema."}
        className="mb-3"
        col={{ lg: 9 }}
      >
        <Col className="d-flex justify-content-center flex-column">
          <Row>
            <h5 id="bReason">
              {condominioS?.acronym.toUpperCase()} - {condominioS?.name}
              {condominioS?.status?.charge?.paid === 1 ? (
                <Badge
                  className="badge-pill pl-2 mr-0 ml-md-2"
                  color={"success"}
                  style={{ fontSize: "13px" }}
                >
                  Solvente
                </Badge>
              ) : condominioS?.status?.charge?.paid === 0 ? (
                <Badge
                  value={false}
                  className="badge-pill p-1 pl-2 mr-0 ml-md-2"
                  color={"danger"}
                  style={{ fontSize: "13px" }}
                >
                  Insolvente
                </Badge>
              ) : (
                <Badge
                  className="badge-pill pl-2 mr-0 ml-md-2"
                  color={"success"}
                  style={{ fontSize: "13px" }}
                >
                  Solvente
                </Badge>
              )}
            </h5>
          </Row>
          <Row>
            <span>
              <small className="d-block font-weight-bold mt-2">
                {properties
                  ? `${
                      properties === 1
                        ? "Una propiedad "
                        : `${properties} propiedades`
                    } `
                  : ""}
                {loading ? (
                  <Spinner size="sm" />
                ) : (
                  <>
                    | Pago{" "}
                    <NumberFormat
                      prefix={`${baseCurrency.symbol} `}
                      displayType={"text"}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale
                      value={properties * 1}
                    />
                  </>
                )}
              </small>
              {condominioS?.created_at && (
                <small className="text-danger" style={{ fontSize: "1rem" }}>
                  Fecha de corte{" "}
                  <span data-testid="date">
                    {moment(condominioS?.created_at).format("DD")}
                  </span>{" "}
                  de cada mes
                </small>
              )}
            </span>
          </Row>
        </Col>
      </PageHeader>
      <Card>
        <FalconCardHeader title="Servicios contratados">
          <Row>
            <Col xs={12}>
              <Filter
                keyField="status"
                options={filter_options}
                selectType={setParams}
                dateFilter={false}
              />
            </Col>
          </Row>
        </FalconCardHeader>
        <CardBody
          className={classNames({ "p-0": isIterableArray(condominio) })}
        >
          <PreloadState cond={isIterableArray(condominio)} loading={isLoading}>
            <Or value={true}>
              <Table responsive className="fs--1 mb-0">
                <thead>
                  <tr className="py-2 text-900">
                    <th className="align-middle">Servicio</th>
                    <th className="align-middle text-center">Precio</th>
                    <th className="text-center align-middle">
                      Fecha de creación
                    </th>
                    <th className="text-center align-middle">
                      Estado de servicio
                    </th>
                    <th className="text-center align-middle">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  {condominio?.map((item, i) => (
                    <tr key={i}>
                      <td className="align-middle ">
                        <p className="mb-0">
                          <b>{`${item?.charge?.number_properties} propiedades`}</b>
                        </p>
                      </td>
                      <td className="align-middle text-center">
                        <NumberFormat
                          displayType="text"
                          value={item?.charge?.price}
                          thousandSeparator
                          decimalScale={2}
                          fixedDecimalScale
                          prefix={`${baseCurrency.symbol} `}
                        />
                      </td>
                      <td className="text-center align-middle">
                        <Flex column align="center" justify="center">
                          {/*  {moment(item?.charge?.created_at).fomart(
                            "DD/MM/YYYY"
                          )} */}
                          <b>{moment(item?.charge?.created_at).fromNow()}</b>
                        </Flex>
                      </td>
                      <td className="text-center align-middle">
                        <Or cond={item?.charge?.paid}>
                          <Badge
                            value={1}
                            className="px-3 fs--1"
                            pill
                            color={"soft-success"}
                          >
                            <FontAwesomeIcon
                              icon={faCheck}
                              size="sm"
                              className="mr-1"
                            />{" "}
                            Solvente
                          </Badge>
                          <Badge
                            value={0}
                            className="px-3 fs--1"
                            pill
                            color={"soft-danger"}
                          >
                            <FontAwesomeIcon
                              icon={faTimes}
                              size="sm"
                              className="mr-1"
                            />{" "}
                            Pendiente por pago
                          </Badge>
                        </Or>
                      </td>
                      <td className="text-center align-middle">
                        {!loading ? (
                          <UncontrolledDropdown
                            direction="left"
                            className="d-inline-block"
                          >
                            <DropdownToggle color="falcon-default" size="sm">
                              <FontAwesomeIcon icon="ellipsis-h" />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <Link
                                to={{
                                  pathname: `/dashboard/${moduleBase}/${condominiumId}/my/service/${item?.charge?.id}/payment`,
                                  state: {
                                    amount: item?.charge?.price * properties,
                                    paid: item?.charge?.paid,
                                    service: `${item?.charge?.number_properties} propiedades`,
                                    date: item?.charge?.created_at,
                                  },
                                }}
                              >
                                <DropdownItem>Reportar pago</DropdownItem>
                              </Link>
                              <DropdownItem
                                tag={Link}
                                to={`/dashboard/${moduleBase}/${condominiumId}/my/service/${item?.charge?.id}`}
                              >
                                Ver mis pagos
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        ) : (
                          <Spinner size="sm" />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Or>
            <Or value={false} cond={!!error}>
              <Message
                value={false}
                color={"info"}
                className="p-3"
                align="left"
                icon={faInfoCircle}
              >
                Aún no hay pagos para mostrar.
              </Message>
              <Or value={true}>
                <Alert color="danger" className="mb-0">
                  Esta página no está disponible
                  <Button
                    data-testid="Button"
                    color="link"
                    size="sm"
                    className="ml-1 pl-0"
                    onClick={() => history.goBack()}
                  >
                    Volver
                  </Button>
                </Alert>
              </Or>
            </Or>
          </PreloadState>
        </CardBody>
        {isIterableArray(condominio) && (
          <CardFooter className="border-top">
            <FullPagination
              nextPage={nextPage}
              prevPage={previousPage}
              goToPage={goToPage}
              meta={meta}
              className={"shadow-none"}
              posText={"servicios"}
              perPage={perPage}
            />
          </CardFooter>
        )}
      </Card>
    </Fragment>
  );
};

export default MyService;
